import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dropdown_data: null,
  search_types: null,
  fund_loading: false,
  order_accept_loading: false,
  order_cancel_loading: false,
  transactions: null,
  brokerages: null,
  suitability_status: null,
  tradex_details: null,
  fund_holdings: null,
  fund_document: null,
  fund_document_loading: false,
  funds: null,
  downlaod_fund_trans_document: null,
  buyCloseEndFunds: null,
  sellClientHoldingFunds: null,
  sellOrderClientHoldingOfSelectedFund: null,
  fund_detail: null,
  suitability_data: null,
  buy_order_data: null,
  buy_order_loading: null,
  sell_order_data: null,
  sell_order_loading: null,
  single_Buy_order_data: null,
  single_Buy_order_loading: null,
  single_sell_order_data: null,
  single_sell_order_loading: null,
  my_funds: null,
};

export const fundSlice = createSlice({
  name: 'fund',
  initialState,
  reducers: {
    setDropddownData: (state, action) => {
      state.dropdown_data = action.payload;
    },
    setSearchTypes: (state, action) => {
      state.search_types = action.payload;
    },
    setFundLoading: (state, action) => {
      state.fund_loading = action.payload;
    },
    setOrderAcceptLoading: (state, action) => {
      state.order_accept_loading = action.payload;
    },
    setOrderCancelLoading: (state, action) => {
      state.order_cancel_loading = action.payload;
    },
    setTransactions: (state, action) => {
      state.transactions = action.payload;
    },
    setSuitabilityStatus: (state, action) => {
      state.suitability_status = action.payload;
    },
    setTradexDetails: (state, action) => {
      state.tradex_details = action.payload;
    },
    setFundHoldings: (state, action) => {
      state.fund_holdings = action.payload;
    },
    setFundDocument: (state, action) => {
      state.fund_document = action.payload;
    },
    setFundDocumentLoading: (state, action) => {
      state.fund_document_loading = action.payload;
    },
    setFunds: (state, action) => {
      state.funds = action.payload;
    },
    setDownlaodFundTransDocument: (state, action) => {
      state.downlaod_fund_trans_document = action.payload;
    },
    setBuyCloseEndFunds: (state, action) => {
      state.buyCloseEndFunds = action.payload;
    },
    setSellClientHoldingFunds: (state, action) => {
      state.sellClientHoldingFunds = action.payload;
    },
    setSellOrderClientHoldingOfSelectedFund: (state, action) => {
      state.sellOrderClientHoldingOfSelectedFund = action.payload;
    },
    setFundDetail: (state, action) => {
      state.fund_detail = action.payload;
    },
    setSuitabilityData: (state, action) => {
      state.suitability_data = action.payload;
    },
    setBuyOrder: (state, action) => {
      state.buy_order_data = action.payload;
    },
    setBuyOrderLoading: (state, action) => {
      state.buy_order_loading = action.payload;
    },
    setSellOrder: (state, action) => {
      state.sell_order_data = action.payload;
    },
    setSellOrderLoading: (state, action) => {
      state.sell_order_loading = action.payload;
    },
    setSingleBuyOrder: (state, action) => {
      state.single_Buy_order_data = action.payload;
    },
    setSingleBuyOrderLoading: (state, action) => {
      state.single_Buy_order_loading = action.payload;
    },
    setSingleSellOrder: (state, action) => {
      state.single_sell_order_data = action.payload;
    },
    setSingleSellOrderLoading: (state, action) => {
      state.single_sell_order_loading = action.payload;
    },
    setMyFunds: (state, action) => {
      state.my_funds = action.payload;
    },
  },
});

export const {
  setDropddownData,
  setSearchTypes,
  setFundLoading,
  setOrderAcceptLoading,
  setOrderCancelLoading,
  setTransactions,
  setSuitabilityStatus,
  setTradexDetails,
  setFundHoldings,
  setFundDocument,
  setFundDocumentLoading,
  setFunds,
  setDownlaodFundTransDocument,
  setBuyCloseEndFunds,
  setSellClientHoldingFunds,
  setSellOrderClientHoldingOfSelectedFund,
  setFundDetail,
  setSuitabilityData,
  setBuyOrder,
  setBuyOrderLoading,
  setSellOrder,
  setSellOrderLoading,
  setSingleBuyOrder,
  setSingleBuyOrderLoading,
  setSingleSellOrder,
  setSingleSellOrderLoading,
  setMyFunds,
} = fundSlice.actions;

export default fundSlice.reducer;
